export default class RedirectHelper {
    static storeUrl() {
        window.localStorage.setItem('lastUrl', window.location.href);
    }

    static redirect() {
        let lastUrl = window.localStorage.getItem('lastUrl');
        if(lastUrl !== null) {
            window.localStorage.removeItem('lastUrl');
            window.location.href = lastUrl;
        }
    }
}


// WEBPACK FOOTER //
// ./web/src/services/RedirectHelper.js